"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEmojiPicker = exports.observeCategories = void 0;
var _react = _interopRequireDefault(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _plateEmoji = require("@udecode/plate-emoji");
/* copied from https://github.com/udecode/plate/blob/v36/packages/emoji/src/utils/EmojiPicker/useEmojiPicker.ts
 * if we attempt to use the exported hook from plate-emoji we get an error about a missing createEmojiNode function
 * We can try to remove it after upgrading react and plateJs
 * */

var setVisibleSections = function setVisibleSections(entries, visibleSections) {
  var _iterator = _createForOfIteratorHelper(entries),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;
      var id = entry.target.dataset.id;
      visibleSections.set(id, entry.isIntersecting);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var getSectionInFocus = function getSectionInFocus(visibleSections) {
  var _iterator2 = _createForOfIteratorHelper(visibleSections),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
        id = _step2$value[0],
        ratio = _step2$value[1];
      if (ratio) {
        return id;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
var observeCategories = function observeCategories(_ref) {
  var ancestorRef = _ref.ancestorRef,
    emojiLibrary = _ref.emojiLibrary,
    setFocusedAndVisibleSections = _ref.setFocusedAndVisibleSections;
  var observerOptions = {
    root: ancestorRef.current,
    threshold: 0
  };
  var visibleSections = new Map();
  var observer = new IntersectionObserver(function (entries) {
    setVisibleSections(entries, visibleSections);
    var focusedSectionId = getSectionInFocus(visibleSections);
    focusedSectionId && setFocusedAndVisibleSections(visibleSections, focusedSectionId);
  }, observerOptions);
  var _iterator3 = _createForOfIteratorHelper(emojiLibrary.getGrid().sections()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var section = _step3.value;
      if (section.root.current) observer.observe(section.root.current);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return observer;
};
exports.observeCategories = observeCategories;
var useEmojiPicker = function useEmojiPicker(_ref2) {
  var closeOnSelect = _ref2.closeOnSelect,
    emojiLibrary = _ref2.emojiLibrary,
    indexSearch = _ref2.indexSearch;
  var editor = (0, _plateCommon.useEditorRef)();
  var _ref3 = (0, _plateEmoji.EmojiPickerState)(),
    _ref4 = _slicedToArray(_ref3, 2),
    state = _ref4[0],
    dispatch = _ref4[1];
  var refs = _react.default.useRef({
    content: /*#__PURE__*/_react.default.createRef(),
    contentRoot: /*#__PURE__*/_react.default.createRef()
  });
  var setIsOpen = _react.default.useCallback(function (isOpen) {
    dispatch({
      type: isOpen ? 'SET_OPEN' : 'SET_CLOSE'
    });
  }, [dispatch]);
  var setFocusedAndVisibleSections = _react.default.useCallback(function (visibleSections, categoryId) {
    dispatch({
      payload: {
        focusedCategory: categoryId,
        visibleCategories: visibleSections
      },
      type: 'SET_FOCUSED_AND_VISIBLE_CATEGORIES'
    });
  }, [dispatch]);
  var handleSearchInput = _react.default.useCallback(function (input) {
    var value = String(input).replaceAll(/\s/g, '');
    if (!value && !input) {
      dispatch({
        type: 'CLEAR_SEARCH'
      });
      return;
    }
    var hasFound = indexSearch.search(value).hasFound();
    dispatch({
      payload: {
        hasFound: hasFound,
        searchResult: indexSearch.get(),
        searchValue: value
      },
      type: 'UPDATE_SEARCH_RESULT'
    });
  }, [dispatch, indexSearch]);
  var setSearch = _react.default.useCallback(function (value) {
    value ? handleSearchInput(value) : dispatch({
      type: 'CLEAR_SEARCH'
    });
  }, [dispatch, handleSearchInput]);
  var clearSearch = _react.default.useCallback(function () {
    dispatch({
      type: 'CLEAR_SEARCH'
    });
  }, [dispatch]);
  var onMouseOver = _react.default.useCallback(function (emoji) {
    dispatch({
      payload: {
        emoji: emoji
      },
      type: 'SET_EMOJI'
    });
  }, [dispatch]);
  var updateFrequentEmojis = _react.default.useCallback(function (emojiId) {
    emojiLibrary.updateFrequentCategory(emojiId);
    dispatch({
      payload: {
        frequentEmoji: emojiId,
        isOpen: closeOnSelect ? false : state.isOpen
      },
      type: 'UPDATE_FREQUENT_EMOJIS'
    });
  }, [closeOnSelect, dispatch, emojiLibrary, state.isOpen]);
  var onSelectEmoji = _react.default.useCallback(function (emoji) {
    (0, _plateEmoji.insertEmoji)(editor, emoji);
    updateFrequentEmojis(emoji.id);
  }, [editor, updateFrequentEmojis]);
  var handleCategoryClick = _react.default.useCallback(function (categoryId) {
    dispatch({
      payload: {
        focusedCategory: categoryId
      },
      type: 'SET_FOCUSED_CATEGORY'
    });
    var getSectionPositionToScrollIntoView = function getSectionPositionToScrollIntoView() {
      var _refs$current$content, _refs$current$content2, _refs$current$content3, _refs$current$content4, _section$root$current, _section$root$current2;
      var trashHold = 1;
      var section = emojiLibrary.getGrid().section(categoryId);
      var contentRootScrollTop = (_refs$current$content = (_refs$current$content2 = refs.current.contentRoot.current) === null || _refs$current$content2 === void 0 ? void 0 : _refs$current$content2.scrollTop) !== null && _refs$current$content !== void 0 ? _refs$current$content : 0;
      var contentRootTopPosition = (_refs$current$content3 = (_refs$current$content4 = refs.current.contentRoot.current) === null || _refs$current$content4 === void 0 ? void 0 : _refs$current$content4.getBoundingClientRect().top) !== null && _refs$current$content3 !== void 0 ? _refs$current$content3 : 0;
      var sectionTopPosition = (_section$root$current = section === null || section === void 0 ? void 0 : (_section$root$current2 = section.root.current) === null || _section$root$current2 === void 0 ? void 0 : _section$root$current2.getBoundingClientRect().top) !== null && _section$root$current !== void 0 ? _section$root$current : 0;
      return trashHold + contentRootScrollTop + sectionTopPosition - contentRootTopPosition;
    };
    if (refs.current.contentRoot.current) {
      refs.current.contentRoot.current.scrollTop = getSectionPositionToScrollIntoView();
    }
  }, [dispatch, emojiLibrary]);
  _react.default.useEffect(function () {
    if (state.isOpen && !state.isSearching) {
      // Timeout to allow the category element refs to populate
      setTimeout(function () {
        observeCategories({
          ancestorRef: refs.current.contentRoot,
          emojiLibrary: emojiLibrary,
          setFocusedAndVisibleSections: setFocusedAndVisibleSections
        });
      }, 0);
    }
  }, [emojiLibrary, state.isOpen, state.isSearching, setFocusedAndVisibleSections]);
  return _objectSpread({
    clearSearch: clearSearch,
    emoji: state.emoji,
    emojiLibrary: emojiLibrary,
    handleCategoryClick: handleCategoryClick,
    i18n: _plateEmoji.i18n,
    onMouseOver: onMouseOver,
    onSelectEmoji: onSelectEmoji,
    refs: refs,
    setIsOpen: setIsOpen,
    setSearch: setSearch
  }, state);
};
exports.useEmojiPicker = useEmojiPicker;